import './Hero.css';

function Hero({ onDiscoverClick, onParticipateClick }) {
  const yearsOfActivity = new Date().getFullYear() - 2012;

  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-left">
          <div className="hero-text">
            <h1 className="hero-title">Consulta Giovanile di Ortona</h1>
            <p className="hero-subtitle">Dare voce ai giovani, costruire il futuro insieme</p>
            <p className="hero-description">
              Siamo un organo comunale di partecipazione che rappresenta e promuove 
              le istanze dei giovani del territorio. Attraverso progetti, eventi e iniziative, 
              lavoriamo per creare opportunità e valorizzare il talento delle nuove generazioni.
            </p>
            <div className="hero-buttons">
              <button className="btn-secondary" onClick={onDiscoverClick}>Scopri chi siamo</button>
              <button className="btn-secondary" onClick={onParticipateClick}>Partecipa</button>
            </div>
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <h3>{yearsOfActivity}</h3>
              <p>Anni di attività</p>
            </div>
            <div className="stat-item">
              <h3>90+</h3>
              <p>Eventi Organizzati</p>
            </div>
            <div className="stat-item">
              <h3>20+</h3>
              <p>Membri Attivi</p>
            </div>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-image">
            <img 
              src="https://firebasestorage.googleapis.com/v0/b/consulta-giovanile-di-ortona.appspot.com/o/logo_consulta.png?alt=media&token=dda986a6-79b4-4e89-bd3e-6893adbe6a11" 
              alt="Consulta Giovanile di Ortona"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
